module.exports = __webpack_public_path__ + "static/media/luana.247d6f84.jpg";